import React from "react";
import { MESH_BG } from "@/components/integrations/brand";

/**
 * Lo stile della barra laterale, lo stesso delle sezioni: la voce scelta e'
 * una pillola bianca con l'ombra leggera (come l'Interruttore) e la sua icona
 * prende il viola delle intestazioni di pagina.
 */
export const VOCE =
  "text-[#334155] hover:bg-[#F1F5F9] hover:text-[#020617] [&>svg]:text-[#64748B] data-[active=true]:bg-white data-[active=true]:text-[#020617] data-[active=true]:shadow-[0_1px_2px_rgba(15,23,42,0.08),0_0_0_1px_#E2E8F0] [&[data-active=true]>svg]:text-[#A855F7]";

/** Il titolo di un gruppo di voci. */
export const ETICHETTA = "text-xs font-medium text-[#94A3B8]";

/**
 * L'iniziale di un nome in un quadratino: per gli assistenti (grigio, viola
 * quello aperto) e, con `grande`, per l'organizzazione, sul gradiente
 * dell'onboarding.
 */
export function Iniziale({ nome, scelto = false, grande = false }) {
  const lettera = (nome || "?").trim().charAt(0).toUpperCase() || "?";
  if (grande) {
    return (
      <span
        aria-hidden="true"
        className="flex size-8 shrink-0 items-center justify-center rounded-[10px] border border-[#E2E8F0] text-sm font-semibold text-[#020617]"
        style={{ background: MESH_BG }}
      >
        {lettera}
      </span>
    );
  }
  return (
    <span
      aria-hidden="true"
      className={`flex size-5 shrink-0 items-center justify-center rounded-[6px] text-[10px] font-semibold ${
        scelto ? "bg-[#A855F7]/10 text-[#A855F7]" : "bg-[#E2E8F0] text-[#475569]"
      }`}
    >
      {lettera}
    </span>
  );
}
